export default __webpack_public_path__ + "static/media/gallery_11.86934605.jpg";